import { render, staticRenderFns } from "./RiwayatKurir.vue?vue&type=template&id=6fa5ac1a"
import script from "./RiwayatKurir.vue?vue&type=script&lang=js"
export * from "./RiwayatKurir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports